<div
	id="hs-offcanvas-right"
	class="hs-overlay fixed top-0 end-0 transition-all duration-300 transform h-full max-w-xs w-full bg-white border-s z-[8]"
	role="dialog"
	tabindex="-1"
	[class.translate-x-0]="isOpen"
	[class.translate-x-full]="!isOpen"
	aria-labelledby="hs-offcanvas-right-label"
>
	<div class="px-4 pt-[130px] menu_canvas">
		<ul *ngIf="menuOffcanvasRigthDesktop && menuOffcanvasRigthDesktop[0]?.items">
			@for (item of menuOffcanvasRigthDesktop[0].items; track item.id) { @if(item.nueva_ventana){
			<li>
				<a target="_blank" [href]="item.url_personalizada || item.url">{{ item.nombre }}</a>
			</li>
			} @else{
			<li routerLinkActive="active">
				<a [routerLink]="item.url_personalizada || item.url">{{ item.nombre }}</a>
			</li>
			} }
		</ul>
		<!-- <ul *showOnScreenSizeC="'small | small-s | medium'">
			<li><a [routerLink]="'/'">Inicio</a></li>
			@for (menu of filteredMenusMobile$ | async; track menu.id) { @for (item of menu.menuItems; track item.id) {
			@if(item.nuevaVentana === 'SI'){
			<li>
				<a target="_blank" [href]="item.url">{{ item.nombre }}</a>
			</li>
			} @else{
			<li routerLinkActive="active">
				<a [routerLink]="item.url">{{ item.nombre }}</a>
			</li>
			} } }
		</ul> -->
	</div>
</div>
